<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
        <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->
  
            <div class="page-wrapper">
  
                    <!--begin::content-->
                    <div class="page-content">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="row mb-3">
                                            <h4 style="margin-right: 5px" class="float-start">{{$t("titleCmlDetailDataSAP") }}</h4>
                                        </div>
                                        <div class="card-body mt-0">
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('idBillingHeader')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="idBillingHeader"
                                                    :placeholder="$t('idBillingHeader')" v-model="formsHeader.idBillingHeader"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('transactionDate_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="transactionDate"
                                                    :placeholder="$t('transactionDate_txt')" v-model="formsHeader.transactionDate"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                    {{$t('DataCustSapTotalRowsCount')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="DataCustSapTotalRowsCount"
                                                    :placeholder="$t('DataCustSapTotalRowsCount')" v-model="formsDataSumSAP.DataCustSapTotalRowsCount"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                    {{$t('DataCustSapTotalRowsCancelCount')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="BtDetailDataCustSapCancelCount"
                                                    :placeholder="$t('DataCustSapTotalRowsCancelCount')" v-model="formsDataSumSAP.BtDetailDataCustSapCancelCount"
                                                    disabled />
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('customerId')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="customerId"
                                                    :placeholder="$t('customerId')" v-model="formsHeader.customerId"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('warehouseId_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="warehouseId"
                                                    :placeholder="$t('warehouseId_txt')" v-model="formsHeader.warehouseId"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                    {{$t('DataCustSapMatchCount')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="DataCustSapMatchCount"
                                                    :placeholder="$t('DataCustSapMatchCount')" v-model="formsDataSumSAP.DataCustSapMatchCount"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                    {{$t('DataCustSapUnmatchCount')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="DataCustSapUnmatchCount"
                                                    :placeholder="$t('DataCustSapUnmatchCount')" v-model="formsDataSumSAP.DataCustSapUnmatchCount"
                                                    disabled />
                                                </div>
                                            </div>   
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('statusTxt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="status"
                                                    :placeholder="$t('statusTxt')" v-model="formsHeader.status"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{ $t('amount_txt') }}
                                                    </label>
                                                    <input type="text" class="form-control" id="amount"
                                                    :placeholder="$t('amount_txt')" v-model="formsHeader.amount"
                                                    disabled />
                                                </div>
                                            </div>   
                                                
                                        </div>
                                        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                            style="margin-right: 5px" @click.prevent="downloadData()">
                                            <span class="mdi mdi-download h4"></span>
                                            {{ $t("downloadData") }} .xlsx
                                        </button>
                                        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                            style="margin-right: 5px" @click.prevent="downloadDataWMS()">
                                            <span class="mdi mdi-download h4"></span>
                                            {{ $t("downloadDataWMS") }} .xlsx
                                        </button>
                                        <button class="btn btn-primary text-light fw-bolder btn-icon-text"
                                            @click="backForm" type="button">
                                            <i class="link-icon mdi mdi-arrow-left"></i>
                                            {{ $t("backMess") }}
                                        </button>
                                    </div>
                                    <div class="card-body" v-if="this.formsHeader.status === 'COMPLETED' || this.formsHeader.status === 'PROCESSING'">
                                        <vue-good-table 
                                        title="list-billing-cml-billing-detail-data-sap"
                                        ref="list-billing-cml-billing-detail-data-sap"
                                        :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}" 
                                        mode="remote" styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" 
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" 
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" 
                                        :totalRows="totalRecords" 
                                        :line-numbers="true"
                                        :isLoading.sync="isLoading" 
                                        :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" 
                                        :rows="rows" 
                                        :columns="columns">

                                            <div slot="table-actions">
                                                {{ $t("no_select_data") }}
                                            </div>
                                            <div slot="selected-row-actions">
                                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>
                                                <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                                    $t("unselect_data_txt")
                                                }} </button>
                                            </div>

                                            <template slot="column-filter" slot-scope="{ column }">
                                                <span v-if="column.filterOptions.customFilter">
                                                    <span v-if="column.field == 'postDate'">
                                                        <date-range-picker style="width:100%" @update="trxDateChange"
                                                            control-container-class="form-control"
                                                            :locale-data="{ format: 'yyyy-mm-dd' }" v-model="trxDate"
                                                            :opens="opens" :singleDatePicker="false" :timePicker24Hour="false"
                                                            :timePicker="false" :showWeekNumbers="false">
                                                            <div slot="header" slot-scope="header" class="slot">
                                                                <a @click="cleartrxDateChange()" class="float-end"
                                                                    style="margin-right: 5px;color:red;">Clear Calendar</a>
                                                                <span v-if="header.in_selection"> - in selection</span>
                                                                <br>
                                                            </div>
                                                        </date-range-picker>
                                                    </span>
                                                </span>
                                            </template>

                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" v-if="permision_role.method_update && props.row.status === 'MATCH' || permision_role.method_update && props.row.status === 'UNMATCH'" title="CANCEL" @click.prevent=" changeStatusData(props.index, props.row , 'CANCEL')">
                                                        <button class="btn btn-danger btn-xs">CANCEL</button>
                                                    </a>
                                                    <a href="#" v-else @click.prevent="changeStatusData(props.index, props.row, 'UNMATCH')">
                                                        <button class="btn btn-primary btn-xs">UNMATCH</button>
                                                    </a>
                                                </span>
                                                <span v-else-if="props.column.field == 'status'">
                                                    <span v-if="props.row.status == 'MATCH'" class="badge bg-info"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'UNMATCH'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>

                                        </vue-good-table>
                                    </div>

                                    <div class="card-body" v-else>

                                        <vue-good-table 
                                        title="list-billing-cml-billing-detail-data-sap"
                                        ref="list-billing-cml-billing-detail-data-sap"
                                        :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}" 
                                        mode="remote" styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" 
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" 
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" 
                                        :totalRows="totalRecords" 
                                        :line-numbers="true"
                                        :isLoading.sync="isLoading" 
                                        :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" 
                                        :rows="rows" 
                                        :columns="columns">
                                            <div slot="table-actions">
                                                {{ $t("no_select_data") }}
                                            </div>

                                            <template slot="column-filter" slot-scope="{ column }">
                                                <span v-if="column.filterOptions.customFilter">
                                                    <span v-if="column.field == 'postDate'">
                                                        <date-range-picker style="width:100%" @update="trxDateChange"
                                                            control-container-class="form-control"
                                                            :locale-data="{ format: 'yyyy-mm-dd' }" v-model="trxDate"
                                                            :opens="opens" :singleDatePicker="false" :timePicker24Hour="false"
                                                            :timePicker="false" :showWeekNumbers="false">
                                                            <div slot="header" slot-scope="header" class="slot">
                                                                <a @click="cleartrxDateChange()" class="float-end"
                                                                    style="margin-right: 5px;color:red;">Clear Calendar</a>
                                                                <span v-if="header.in_selection"> - in selection</span>
                                                                <br>
                                                            </div>
                                                        </date-range-picker>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    -
                                                </span>
                                                <span v-else-if="props.column.field == 'status'">
                                                    <span v-if="props.row.status == 'MATCH'" class="badge bg-info"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'UNMATCH'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>

                                        </vue-good-table>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::content-->
  
                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->


            </div>

      </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
    name: "CmlBillingDetailDataSAP",
    props: {},
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker
    },
    data() {
        return {
            opens:"center",
            locale:{
                format:"yyyy-mm-dd",
            },
            trxDate: {
                startDate: null,
                endDate: null
            },
            firstDates: {
                startDate: null,
                endDate: null
            },
            highlighted:{
                dates: [ // Highlight an array of dates
                    new Date(),
                ],
            },
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role:[],
            langs: ["id", "en"],
            detailUser: [],
            idBillingHeader: [],
            detailDivisi: [],
            totalRecords: 0,
            trxDateFrom: "",
            trxDateTo: "",
            firstBilingDate: "",
            columns: [
            {
            label: this.$t("idDetailCust"),
            field: "idDetailCust",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("idDetailCust"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("status"),
            field: "status",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("status"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['MATCH','UNMATCH', 'CANCEL'], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            
            {
            label: this.$t("materialDoc"),
            field: "materialDoc",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("materialDoc"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("postDate"),
            field: "postDate",
            width: "100px",
            filterOptions: {
                customFilter: true,
                enabled: true, // enable filter for this column
                placeholder: this.$t("postDate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("materialNo"),
            field: "materialNo",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("materialNo"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("materialDesc"),
            field: "materialDesc",
            width: "300px",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("materialDesc"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("qtyUnit"),
            field: "qtyUnit",
            filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("qtyUnit"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("uom"),
            field: "uom",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("uom"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
                label: this.$t("action_txt"),
                field: "actions",
                width: '100px',
                sortable: false,
                filterOptions: {
                customFilter: false,
                enabled: false, 
                },
            },
            {
            label: this.$t("plantCode"),
            field: "plantCode",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("plantCode"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
            },
            },
            {
            label: this.$t("storageLocation"),
            field: "storageLocation",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("storageLocation"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("movementType"),
            field: "movementType",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("movementType"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("key1"),
            field: "key1",
            width: '200px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("key1"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("reference"),
            field: "reference",
            width: "200px",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("reference"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            
            {
            label: this.$t("docHeader"),
            width: '100px',
            field: "docHeader",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("docHeader"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("batch"),
            field: "batch",
            width: "150px",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("batch"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("purchaseOrder"),
            field: "purchaseOrder",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("purchaseOrder"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("debitOrCredit"),
            field: "debitOrCredit",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("debitOrCredit"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("userName"),
            field: "userName",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("userName"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("create_by_txt"),
            field: "addWho",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("create_by_txt"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("update_by_txt"),
            field: "editWho",
            width: '100px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("update_by_txt"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            ],
            rows: [],
            rowsSelection: [],
            idCodeLkupsSelections: [],
            forms: {idBillingDetail: "",  idBillingHeader:"",  chargeCategory:"", chargeType:"", SAPMaterialCode:"", SAPDivision:"",  amountCategory:"" , addwho:"", editwho:"",  qtyCharge:"", rate:""},
            formsHeader: {idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"" , amount:"", idRateHeader:"",  transactionDate:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
            formsDataSumSAP:{ BtDetailDataCustSapCancelCount: "0", DataCustSapTotalRowsCount: "0", DataCustSapMatchCount: "0", DataCustSapUnmatchCount: "0" },

        };
    },
    watch: {},
    methods: {
    
    submitBillingListData(){
        console.log("ok")
    },

    resetForm(){
        this.fileOvertime              = ""
        this.fileExtraHandling         = ""
        this.fileDataSAP               = ""
        this.fileDataAdditionalWMS     = ""
        this.clearrecalculateDates()
    },

    cek_message(status, msg) {
          if (status == "200") {
              this.success(msg);
          }
    },

    toCurrency (value) {
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'IDR'
        });
        return formatter.format(value);
    },

    fade(sType) {
          this.isLoading = sType;
    },

    loading() {
          this.fade(true);
          setTimeout(() => {
              this.fade(false);
          }, 1000); // hide the message after 3 seconds
    },

    resultError(data){
          var count = Object.keys(data).length;
          for (var x = 0; x < count; x++) {
              var nameOb = Object.keys(data)[x];
              var objectData = data[nameOb];
              for (var y = 0; y < objectData.length; y++) {
              this.error(objectData[y]);
              }
          }
    },

    success(kata) {
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
              // onShown: function() {
              //     console.log('asdasdasd');
              //     //window.location.href = '/';
              // }
          });

          Toast.fire({
              icon: "success",
              title: kata,
          });
    },

    error(kata){
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
          });
          Toast.fire({
              icon: "error",
              title: kata,
          });
    },

    logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
    },

    backForm() {
        var params = this.$onRandom(this.formsHeader.idBillingHeader);
        window.location.href = "/billing-cml/billing/header/detail/" + params;
    },


    loadItems() {

            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo

            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-index-detail-data-cust-sap/" + params[0];
            this.isLoading = true;


            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idDetailCust=${this.serverParams.columnFilters.idDetailCust}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&materialNo=${this.serverParams.columnFilters.materialNo}&status=${this.serverParams.columnFilters.status}&reference=${this.serverParams.columnFilters.reference}&userName=${this.serverParams.columnFilters.userName}&debitOrCredit=${this.serverParams.columnFilters.debitOrCredit}&purchaseOrder=${this.serverParams.columnFilters.purchaseOrder}&batch=${this.serverParams.columnFilters.batch}&docHeader=${this.serverParams.columnFilters.docHeader}&materialDesc=${this.serverParams.columnFilters.materialDesc}&uom=${this.serverParams.columnFilters.uom}&materialDoc=${this.serverParams.columnFilters.materialDoc}&movementType=${this.serverParams.columnFilters.movementType}&storageLocation=${this.serverParams.columnFilters.storageLocation}&plantCode=${this.serverParams.columnFilters.plantCode}&editWho=${this.serverParams.columnFilters.editWho}&addWho=${this.serverParams.columnFilters.addWho}&key1=${this.serverParams.columnFilters.key1}`,
                    { timeout: 30000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }

                });
    },

    downloadData() {
                var params = this.$onBehind(this.$route.params.id);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-index-detail-data-cust-sap/" + params[0];
                this.isLoading = true;
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";
         
                let trxDateFrom = this.trxDateFrom
                let trxDateTo   = this.trxDateTo

                return this.$http
                .get(
                    baseURI +
                    `?key1=${this.serverParams.columnFilters.key1}&editWho=${this.serverParams.columnFilters.editWho}&addWho=${this.serverParams.columnFilters.addWho}&reference=${this.serverParams.columnFilters.reference}&userName=${this.serverParams.columnFilters.userName}&debitOrCredit=${this.serverParams.columnFilters.debitOrCredit}&purchaseOrder=${this.serverParams.columnFilters.purchaseOrder}&batch=${this.serverParams.columnFilters.batch}&docHeader=${this.serverParams.columnFilters.docHeader}&materialDesc=${this.serverParams.columnFilters.materialDesc}&uom=${this.serverParams.columnFilters.uom}&materialDoc=${this.serverParams.columnFilters.materialDoc}&movementType=${this.serverParams.columnFilters.movementType}&storageLocation=${this.serverParams.columnFilters.storageLocation}&plantCode=${this.serverParams.columnFilters.plantCode}&materialNo=${this.serverParams.columnFilters.materialNo}&status=${this.serverParams.columnFilters.status}&idDetailCust=${this.serverParams.columnFilters.idDetailCust}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
    },

    downloadDataWMS() {
                var params = this.$onBehind(this.$route.params.id);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/download-data-wms-for-sap/" + params[0];
                this.isLoading = true;
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";

                return this.$http
                .get(
                    baseURI +
                    `?download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
    },


    updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
            this.getDataSummaryBtDetailDataCustSap();
    },

    onColumnFilter(params) {
            this.updateParams(params);
    },

    onPageChange(params) {
            this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
    },

    onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
    },

    selectionChanged(ev) {

        this.rowsSelection = [];
        this.idCodeLkupsSelections  = [];
        this.rowsSelection = ev.selectedRows;

        this.rowsSelection.forEach((item) => {
        this.idCodeLkupsSelections.push(item.idDetailCust);

        });

    },

    trxDateChange() {
        if (this.trxDate.startDate && this.trxDate.endDate) {
            this.trxDateFrom = this.$moment(String(this.trxDate.startDate)).format('YYYY-MM-DD');
            this.trxDateTo = this.$moment(String(this.trxDate.endDate)).format('YYYY-MM-DD');
            this.loadItems()
            this.getDataSummaryBtDetailDataCustSap()
        }

    },

    cleartrxDateChange() {
        this.trxDate = {
            startDate: null,
            endDate: null
        };
        this.trxDateFrom = ""
        this.trxDateTo = ""
        this.loadItems()
        this.getDataSummaryBtDetailDataCustSap()
    },



    fetchIt() {
          const userDatas       = this.$getUserInfo();
          this.userData         = userDatas.sub;
          // this.permision_role = userDatas.sub.permision_role;
          let rolePermision     = [];
          userDatas.sub.permision_role.forEach(function(permision){
              if(permision.permission.controller == 'BillingCmlController'){

              rolePermision = permision;
              // console.log(permision);
              }
          });

          if(!rolePermision.method_read){
              this.$router.push("/authorized-error");
          }

          this.permision_role = rolePermision;
          this.loadData();
          this.getDataSummaryBtDetailDataCustSap();

    },

    loadData() {
          this.isLoading = true;
          var params = this.$onBehind(this.$route.params.id);

          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/detail/" + params[0];
          return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
              this.isLoading = false;
              this.formsHeader                      = response.data.datas;
              this.formsHeader.amount               = this.toCurrency(response.data.datas.amount);
              this.bm_rate_header                   = response.data.datas.bm_rate_header;
              this.formsHeader.transactionDate      = response.data.datas.transactionFromDate+"~"+response.data.datas.transactionToDate
          }).catch(error => {
              this.isLoading = false;
            
        
          if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
              
          }else{

              if (error.response) {
                  if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }

          }

          });
    },

    getDataSummaryBtDetailDataCustSap() {
          this.isLoading = true;
          var params = this.$onBehind(this.$route.params.id);

          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/get-data-summary-customer-sap/" + params[0];
          return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
              this.isLoading = false;
              this.formsDataSumSAP            = response.data.datas;
          }).catch(error => {
              this.isLoading = false;
        
          if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
              
          }else{

              if (error.response) {
                  if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      //this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }

          }

          });
    },


    selectionChangeStatus(){
        this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataSend"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "UNMATCH",
            cancelButtonText: 'CANCEL',
            }).then((result) => {
                if (result.value) 
                {
                        this.isLoading = true;

                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idDetailCusts: this.idCodeLkupsSelections,
                            status: "UNMATCH",
                        };
                        
                        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                            this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                                if (response.data.status === 200) 
                                {
                                    this.success(response.data.datas.messages);
                                    this.idCodeLkupsSelections = [];
                                    this.loadItems();
                                    this.getDataSummaryBtDetailDataCustSap();
                                } 
                                else 
                                {
                                    this.errors = response.data.errors;
                                    this.resultError(response.data.errors);
                                }
                            }).catch((error) => {
                                    this.loading();

                                if(error.code == "ECONNABORTED"){
                                    this.error(this.$t("check_internet_connection_txt"));
                                }else{
                                if (error.response){
                                    if(error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    }else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    }else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    }else{
                                        this.$router.push('/page-not-found');
                                    }
                                }

                                }

                        });

                }
                else
                {
                            
                        this.isLoading = true;
                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idDetailCusts: this.idCodeLkupsSelections,
                            status: "CANCEL",
                        };

                        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                            this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();
                                this.getDataSummaryBtDetailDataCustSap();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                                this.loading();
                              
                                if(error.code == "ECONNABORTED"){
                                this.error(this.$t("check_internet_connection_txt"));
                                }else{

                                    if (error.response) {
                                        if(error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        }else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        }else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        }else{
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            });


                }
        });

    },

    removeSelections(){
        this.idCodeLkupsSelections = [];
        this.$refs['list-billing-cml-billing-detail-data-sap'].unselectAllInternal()
    },

    changeStatusData(index, row , statusNya) {
        this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
        }).then((result) => {
            if (result.value) {
                    var formData = {
                        idBillingHeader: this.formsHeader.idBillingHeader,
                        idDetailCusts: [row.idDetailCust],
                        status: statusNya,
                    };
                    const baseURI =
                        this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                        this.$http
                        .post(baseURI, formData,{ timeout: 60000 })
                        .then((response) => {
                        this.loading();
                        if (response.data.status === 200) {
                            this.success(response.data.datas.messages);
                            this.loadItems();
                            this.getDataSummaryBtDetailDataCustSap();

                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                        }).catch((error) => {
                            this.loading();
                          
                            if(error.code == "ECONNABORTED"){
                                this.error(this.$t("check_internet_connection_txt"));
                            }else{
                                if (error.response) {
                                    if(error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    }else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    }else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    }else{
                                        this.$router.push('/page-not-found');
                                    }
                                }

                            }
                        });

            }else{
            this.isLoading = false;
            }
        });

    },





    },
    events: {},
    created: function () {},
    mounted() {
        this.fetchIt();
        this.loading();
    },

};

</script>

<style scoped>

.blur-content{
    filter: blur(5px); 
  }

</style>